var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acceptance-time"},[_c('pcg-btn',{staticClass:"prk-button",attrs:{"round":"","text":_vm.acceptanceDateTime,"icon":"far fa-clock"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }